import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AmorphicService } from '../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { WindowService } from '../../../../../common/angular-shared/services/window/window.service';
import { BaseLoginService } from '../../../../../coverpath-common/angular/services/login/base-login.service';
import { Controller } from '../../Controller';

@Injectable()
export class MMDirectLoginService extends BaseLoginService {
    controller: Controller;

    constructor(protected windowService: WindowService,
                protected route: ActivatedRoute,
                protected router: Router,
                private amorphicServiceInject: AmorphicService) {

        super(windowService, route, router, amorphicServiceInject);
    }

    protected getController(): Controller {
        return this.windowService.nativeWindow.controller;
    }

}